import useSwrImmutable from 'swr/immutable';
import { getPartnerConfigurations } from './api';

export const usePartnerConfigurations = () => {
  return useSwrImmutable(['partner-configuration'], async () => {
    return await getPartnerConfigurations();
  });
};
